import { getJsData } from '../../../shared/js/utils/js-data';

document.addEventListener('lbx-results-loaded', () => {
    const cartManipulationData = getJsData().cartManipulation;
    const addToCartLink = cartManipulationData.addToCartLink;

    if (addToCartLink) {
        document.querySelectorAll('[data-luigis-product-id]').forEach((element) => {
            element.addEventListener('click', (event) => {
                const productId = event.currentTarget.dataset.luigisProductId;

                window.naja.makeRequest(
                    'GET',
                    addToCartLink.replace('productId=0', ''),
                    {
                        productId,
                        quantity: 1,
                    },
                    {
                        history: false,
                    }
                );
            });
        });
    }
});
